import { useQuery } from '@tanstack/react-query';
import fetchApi from './fetchApi';

// Seeded from the user the layout embeds, so the first render needs no round trip.
// Login/logout invalidate the query; the staleTime only skips the redundant refetch on mount.
const useMeQuery = () =>
  useQuery<Odoo.User | null>({
    queryKey: ['me'],
    queryFn: () => fetchApi<Odoo.User | null>('/api/users/me'),
    initialData: window.currentUser,
    initialDataUpdatedAt: Date.now(),
    staleTime: 60_000,
  });

export default useMeQuery;
